import { render, staticRenderFns } from "./UpdateAnimalModal.vue?vue&type=template&id=5c3c4362&scoped=true"
import script from "./UpdateAnimalModal.vue?vue&type=script&lang=js"
export * from "./UpdateAnimalModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateAnimalModal.vue?vue&type=style&index=0&id=5c3c4362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3c4362",
  null
  
)

export default component.exports